module.exports = __webpack_public_path__ + "img/transport-activity.a6fbdafa.jpg";